import WorkWithUs from "../components/sections/WorkWithUs";
import BookRideSection from "../components/sections/BookRideSection";
import { Link } from "react-router-dom";

const Faqs = ({ className = "" }) => {
  return (
    <>
      <section className={`faq_wrap section_pt section_pb ${className}`}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="titles justify-content-center">
                <h2 className="wow bounceIn">FAQs</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq_row">
                <div
                  className="accordion accordion-flush wow fadeInUp"
                  id="accordionFlushExample"
                >
                  <div className="row g-4">
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingOne">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="false"
                            aria-controls="flush-collapseOne"
                          >
                            What is Orbi?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingOne"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Orbi is a taxi prebooking platform that lets you
                            book rides in advance, including airport transfers,
                            city tours, railway station pickups, outstation
                            trips, corporate travel, and event transportation.
                            We partner with trusted local transporters to
                            provide reliable service.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo"
                          >
                            How do I book a ride?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingTwo"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            <ul>
                              <li>
                                <p>Open the Orbi app or website.</p>
                              </li>
                              <li>
                                <p>
                                  Select your ride type (airport, city tour,
                                  outstation, corporate, or event).
                                </p>
                              </li>
                              <li>
                                <p>
                                  Enter pickup and drop locations, date, and
                                  time.
                                </p>
                              </li>
                              <li>
                                <p>Choose your preferred vehicle type.</p>
                              </li>
                              <li>
                                <p>Confirm and pay online.</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="flush-headingThree"
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree"
                          >
                            How early do I need to book my ride?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingThree"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            All rides must be{" "}
                            <b>prebooked at least 1 day in advance.</b>{" "}
                            Last-minute bookings are currently not supported.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingFour">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFour"
                            aria-expanded="false"
                            aria-controls="flush-collapseFour"
                          >
                            Can I book rides for multiple stops?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseFour"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingFour"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Yes! For city tours, corporate travel, or event
                            pickups, you can include predefined stops. The
                            system will log each stop during your ride.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingFive">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFive"
                            aria-expanded="false"
                            aria-controls="flush-collapseFive"
                          >
                            How do I pay for my ride?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseFive"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingFive"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            All rides must be paid online via card, UPI, or
                            wallet. Cash payments are <b>not accepted.</b>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingSix">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseSix"
                            aria-expanded="false"
                            aria-controls="flush-collapseSix"
                          >
                            Can I cancel or reschedule my ride?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseSix"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingSix"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            <ul>
                              <li>
                                <p>
                                  <b>Cancellation:</b> You can cancel up to a
                                  certain time before pickup (check app for
                                  exact policy). Some rides may have a
                                  cancellation fee.
                                </p>
                              </li>
                              <li>
                                <p>
                                  <b>Rescheduling:</b> You can reschedule
                                  directly in the app or contact support.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingOne1">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne1"
                            aria-expanded="false"
                            aria-controls="flush-collapseOne1"
                          >
                            How do I know my ride is confirmed?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseOne1"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingOne1"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Once your booking is complete, you’ll receive:
                            <ul className="mt-4">
                              <li>
                                <p>A confirmation email/SMS</p>
                              </li>
                              <li>
                                <p>
                                  Ride details and assigned driver information
                                  in the app
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingTwo2">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo2"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo2"
                          >
                            Are Orbi rides safe?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseTwo2"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingTwo2"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Yes. We partner with verified transporters, and all
                            drivers are background-checked. Vehicle details and
                            driver info are provided before your ride.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="flush-headingThree3"
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree3"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree3"
                          >
                            Can I book for someone else?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseThree3"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingThree3"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Yes. You can provide the passenger’s details at the
                            time of booking.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="flush-headingFour4"
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFour4"
                            aria-expanded="false"
                            aria-controls="flush-collapseFour4"
                          >
                            What if the driver is late?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseFour4"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingFour4"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            If the driver is delayed, you’ll receive updates via
                            the app. You can also contact support for
                            assistance.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="flush-headingFive5"
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFive5"
                            aria-expanded="false"
                            aria-controls="flush-collapseFive5"
                          >
                            How do I contact Orbi support?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseFive5"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingFive5"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            <ul>
                              <li>
                                <p>In-app chat or call option</p>
                              </li>
                              <li>
                                <p>Email: support@orbicabs.com</p>
                              </li>
                              <li>
                                <p>Phone: +91 75 3505 1511, +91 90 4136 4870</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingSix6">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseSix6"
                            aria-expanded="false"
                            aria-controls="flush-collapseSix6"
                          >
                            Do you offer packages for city tours, corporate, or
                            events?
                          </button>
                        </h2>
                        <div
                          id="flush-collapseSix6"
                          className="accordion-collapse collapse"
                          aria-labelledby="flush-headingSix6"
                          data-bs-parent="#accordionFlushExample"
                        >
                          <div className="accordion-body">
                            Yes. Orbi provides predefined packages with fixed
                            stops and durations. Some packages allow limited
                            customization depending on your needs.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* work with us section */}
      <section class="corporate_wrap section_pt section_pb">
        <div class="container">
          <div class="row g-4">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="corporate_col">
                <h2>Corporate Partnerships</h2>
                <p>Join forces with Orbi for seamless corporate mobility.</p>
                <Link to="/corporate" className="explore">
                  Explore More
                </Link>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="corporate_col event_col">
                <h2>Events & Weddings</h2>
                <p>Make your special day even more memorable with Orbi.</p>
                <Link to="/events" className="explore">
                  Explore More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WorkWithUs />

      {/* book ride section */}
      {/* <BookRideSection /> */}
    </>
  );
};

export default Faqs;
